exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".has-access-container svg[data-v-a260d78e]{width:7px;float:left;color:#7ed321}.has-access-container .access-text[data-v-a260d78e]{font-size:11px;color:#7ed321;float:left;padding-right:5px;font-weight:700}.unknown-access-text[data-v-a260d78e]{font-size:11px;color:#575757;font-weight:700}.category-container[data-v-a260d78e]{margin-bottom:25px}", ""]);

// exports
